<script>
  import { onMount, afterUpdate } from 'svelte';
  import { axisLeft } from 'd3-axis';
  import { range } from 'd3-array';
  import { flip } from 'svelte/animate';

  import { hFormatter, hAxisFormatter } from './helper.js';

  export let scale;
  export let initScale;
  export let domain;
  export let initialized = false;

  export let isInset = false;
  export let width = 0;
  export let paddingLeft = 0;
  export let paddingRight = 0;

  $: axis = axisLeft(scale).tickValues([300000000, 200000000, 100000000]);
  let tickLines = range(20000000, 300000000, 20000000);
  let tickLabels = [20, 100000000, 200000000, 300000000];

  $: {
    if (domain[0] === 1 && domain[1] === 300000000) {
      tickLabels = [0.001, 100000000, 200000000, 300000000];

      tickLines = [
        1,
        50000000,
        100000000,
        150000000,
        200000000,
        250000000,
        300000000,
      ];
    } else if (domain[0] === 20 && domain[1] === 100000000) {
      tickLabels = [
        ...[20],
        ...range(25000000, 100000000, 25000000),
        ...[100000000],
      ];

      tickLines = [...range(25000000, 100000000, 25000000), ...[100000000]];
    } else if (domain[0] === 20 && domain[1] === 6000000) {
      tickLabels = [20, 1000000, 2000000, 3000000, 4000000, 5000000, 6000000];

      tickLines = range(500000, 6000000, 500000);
    } else if (domain[0] === 1000 && domain[1] === 300000000) {
      tickLabels = [100000000, 200000000, 300000000];

      tickLines = range(20000000, 300000000, 20000000);
    } else if (domain[0] === 20 && domain[1] === 80000000) {
      tickLabels = [
        20,
        10000000,
        20000000,
        30000000,
        40000000,
        50000000,
        60000000,
        70000000,
        80000000,
      ];

      tickLines = range(5000000, 80000000, 5000000);
    } else {
      tickLabels = [100000000, 200000000, 300000000];
      tickLines = range(20000000, 300000000, 20000000);
    }
  }

  function enter(node, { duration, tick }) {
    const start = initScale(tick);
    const end = scale(tick);
    const diff = end - start;

    return {
      duration,

      css: t => {
        return `
					top: ${start + t * diff}px;
					opacity:${t};`;
      },
    };
  }

  function exit(node, { duration, tick }) {
    const start = initScale(tick);
    const end = scale(tick);
    const diff = end - start;

    return {
      duration,

      css: t => {
        return `
					top: ${end - t * diff}px;
					opacity:${t};`;
      },
    };
  }
</script>

<style type="text/scss">.axis,
.gridline,
.text {
  position: absolute;
  top: 0; }

.text {
  font-size: 12px;
  transform: translate(0, -50%); }
  @media (min-width: 600px) {
    .text {
      font-size: 12px; } }

.axis {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0; }

.gridline {
  border-top: 1px solid #ccc; }

.text {
  color: #a7a7a7;
  text-align: right; }

.init .text,
.init .gridline {
  transition: top 2000ms linear, opacity 2000ms linear; }
</style>

<div class="axis y-axis {initialized ? 'init' : ''} {isInset ? 'inset' : ''}">

  {#each tickLabels as tick, i (tick)}
    <div
      class="text font-display {i === tickLabels.length - 1 ? 'first' : ''}
      {i === 0 ? 'last' : ''}"
      style="top:{scale(tick)}px; right:{width + 10 - paddingLeft}px;"
      in:enter={{ duration: initialized ? 2000 : 0, tick: tick }}
      out:exit={{ duration: initialized ? 2000 : 0, tick: tick }}>
      {isInset ? hAxisFormatter(tick) : hFormatter(tick)}
    </div>
  {/each}

  {#each tickLines as tick, i (tick)}
    <div
      class="gridline"
      style="top:{scale(tick)}px;left:{paddingLeft}px;width:{width - paddingLeft - paddingRight - 1}px;"
      in:enter={{ duration: initialized ? 2000 : 0, tick: tick }}
      out:exit={{ duration: initialized ? 2000 : 0, tick: tick }} />
  {/each}

</div>
